import Rice from '../../../assets/images/plants/rice.jpeg'
import KidneyBean from '../../../assets/images/plants/kidney_bean.jpeg'
import Soybean from '../../../assets/images/plants/soy_bean.jpeg'

const EdiablePlantdata = {
  "data": [
    {
      "id": 161098,
      "common_name": "Rice",
      "slug": "oryza-sativa",
      "scientific_name": "Oryza sativa",
      "year": 1753,
      "bibliography": "Sp. Pl.: 333 (1753)",
      "author": "L.",
      "status": "accepted",
      "rank": "species",
      "family_common_name": "Grass family",
      "genus_id": 5030,
      "image_url": "https://bs.floristic.org/image/o/d22b00ace0483990f6753b0380e647c3688e4214",
      "image": Rice,
      "synonyms": [
        "Oryza perennis",
        "Oryza rubribarbis",
        "Oryza mutica",
        "Oryza segetalis",
        "Oryza repens",
        "Oryza plena",
        "Oryza pubescens",
        "Oryza sativa subsp. japonica",
        "Oryza sativa subsp. indica",
        "Oryza praecox",
        "Oryza elongata",
        "Oryza marginata",
        "Oryza aristata",
        "Oryza pumila",
        "Oryza formosana",
        "Oryza palustris",
        "Oryza communissima",
        "Oryza glutinosa",
        "Oryza denudata",
        "Oryza montana"
      ],
      "genus": "Oryza",
      "family": "Poaceae",
      "links": {
        "self": "/api/v1/species/oryza-sativa",
        "plant": "/api/v1/plants/oryza-sativa",
        "genus": "/api/v1/genus/oryza"
      }
    },
    {
      "id": 165409,
      "common_name": "Kidney bean",
      "slug": "phaseolus-vulgaris",
      "scientific_name": "Phaseolus vulgaris",
      "year": 1753,
      "bibliography": "Sp. pl. 2:723.  1753",
      "author": "L.",
      "status": "accepted",
      "rank": "species",
      "family_common_name": "Pea family",
      "genus_id": 3221,
      "image": KidneyBean,
      "synonyms": [
        "Phaseolus nanus",
        "Phaseolus haematocarpus",
        "Phaseolus asparagioides",
        "Phaseolus principissae",
        "Phaseolus umbilicalis",
        "Phaseolus albus",
        "Phaseolus oblongus",
        "Phaseolus sphaericus",
        "Phaseolus praecox",
        "Phaseolus domingensis",
        "Phaseolus communis",
        "Phaseolus deliciosus",
        "Phaseolus esculentus",
        "Phaseolus subglobosus",
        "Phaseolus cruentus",
        "Phaseolus triangulus",
        "Phaseolus melanospermus",
        "Phaseolus zebra",
        "Phaseolus zembra",
        "Phaseolus lilac",
        "Phaseolus vulgaris var. aborigineus",
        "Phaseolus tumidus",
        "Phaseolus lupinoides",
        "Phaseolus saponaceus",
        "Phaseolus ferrugineus",
        "Phaseolus ionocarpus",
        "Phaseolus mexicanus",
        "Phaseolus romanus",
        "Phaseolus dimidiatus",
        "Phaseolus pisiformis",
        "Phaseolus compressus",
        "Phaseolus nigricans",
        "Phaseolus nigerrimus",
        "Phaseolus ovalispermus",
        "Phaseolus stipularis",
        "Phaseolus aborigineus",
        "Phaseolus mesoleucus",
        "Phaseolus gonospermos",
        "Phaseolus sinensis",
        "Phaseolus saccharatus",
        "Phaseolus vulgaris var. humilis"
      ],
      "genus": "Phaseolus",
      "family": "Fabaceae",
      "links": {
        "self": "/api/v1/species/phaseolus-vulgaris",
        "plant": "/api/v1/plants/phaseolus-vulgaris",
        "genus": "/api/v1/genus/phaseolus"
      }
    },
    {
      "id": 139820,
      "common_name": "Soybean",
      "slug": "glycine-max",
      "scientific_name": "Glycine max",
      "year": 1917,
      "bibliography": "Interpr. Herb. amboin. 274.  1917",
      "author": "Merr. (L.)",
      "status": "accepted",
      "rank": "species",
      "family_common_name": "Pea family",
      "genus_id": 368,
      "image": Soybean,
      "synonyms": [
        "Glycine gracilis",
        "Soja hispida",
        "Soja max",
        "Glycine hispida",
        "Phaseolus max",
        "Soja viridis",
        "Sooja japonica",
        "Glycine hispida var. oodes",
        "Glycine hispida var. quinquefolia",
        "Glycine hispida var. nigra-lutescens",
        "Glycine hispida subsp. lugulata",
        "Glycine hispida var. virescens-virescens",
        "Glycine hispida var. vulgaris",
        "Glycine hispida var. nucata",
        "Glycine hispida var. rara",
        "Glycine hispida var. ovata-lutescens",
        "Glycine hispida var. castanea",
        "Glycine hispida subsp. subvolubilis",
        "Glycine hispida var. nigricans-virescens",
        "Glycine hispida var. nictans",
        "Glycine hispida var. affine-virescens",
        "Glycine hispida var. limbata",
        "Soja angustifolia",
        "Soja japonica",
        "Glycine hispida var. nitens",
        "Glycine hispida var. similis",
        "Glycine hispida var. pura-lutescens",
        "Glycine hispida var. lanceolata",
        "Glycine hispida var. notabilis-lutescens",
        "Glycine hispida var. lubrica",
        "Glycine hispida var. nobilis",
        "Glycine hispida var. lepida",
        "Glycine hispida var. minor-lutescens",
        "Glycine hispida var. brunnea",
        "Glycine hispida var. lutea",
        "Glycine hispida var. pallida-lutescens",
        "Cadelium viride",
        "Glycine hispida var. virescens-lutescens",
        "Cadelium nigrum",
        "Glycine hispida var. affine-lutescens",
        "Glycine hispida var. nigricans-lutescens"
      ],
      "genus": "Glycine",
      "family": "Fabaceae",
      "links": {
        "self": "/api/v1/species/glycine-max",
        "plant": "/api/v1/plants/glycine-max",
        "genus": "/api/v1/genus/glycine"
      }
    },
  ],
  "links": {
    "self": "/api/v1/plants?filter_not%5Bedible_part%5D=null",
    "first": "/api/v1/plants?filter_not%5Bedible_part%5D=null\u0026page=1",
    "next": "/api/v1/plants?filter_not%5Bedible_part%5D=null\u0026page=2",
    "last": "/api/v1/plants?filter_not%5Bedible_part%5D=null\u0026page=7"
  },
  "meta": { "total": 135 }
}

export default EdiablePlantdata